import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const uploadSlice = createSlice({
  name: "upload",
  initialState: {
    token: Cookies.get("token"),
    upload: [
      {
        avatarpic: "",
        birthCertificate: "",
        nationalCard: "",
        passport: "",
        realProfile: "",
        realLicense: "",
        legalProfile: "",
        announcement: "",
        lastAnnouncement: "",
        legalLicense: "",
        formAvatar: "",
        ticket: "",
      },
    ],
  },
  reducers: {
    addToForm: (state, action) => {
      if (action.payload.avatarpic) {
        state.upload[0].avatarpic = action.payload.avatarpic != undefined ? action.payload.avatarpic : "";
      }

      if (action.payload.birthCertificate) {
        state.upload[0].birthCertificate =
          action.payload.birthCertificate != undefined ? action.payload.birthCertificate : "";
      }
      if (action.payload.nationalCard) {
        state.upload[0].nationalCard =
          action.payload.nationalCard != undefined ? action.payload.nationalCard : "";
      }
      if (action.payload.passport) {
        state.upload[0].passport = action.payload.passport != undefined ? action.payload.passport : "";
      }

      if (action.payload.realProfile) {
        state.upload[0].realProfile =
          action.payload.realProfile != undefined ? action.payload.realProfile : "";
      }

      if (action.payload.realLicense) {
        state.upload[0].realLicense =
          action.payload.realLicense != undefined ? action.payload.realLicense : "";
      }

      if (action.payload.legalProfile) {
        state.upload[0].legalProfile =
          action.payload.legalProfile != undefined ? action.payload.legalProfile : "";
      }

      if (action.payload.announcement) {
        state.upload[0].announcement =
          action.payload.announcement != undefined ? action.payload.announcement : "";
      }

      if (action.payload.lastAnnouncement) {
        state.upload[0].lastAnnouncement =
          action.payload.lastAnnouncement != undefined ? action.payload.lastAnnouncement : "";
      }

      if (action.payload.legalLicense) {
        state.upload[0].legalLicense =
          action.payload.legalLicense != undefined ? action.payload.legalLicense : "";
      }

      if (action.payload.formAvatar) {
        state.upload[0].formAvatar = action.payload.formAvatar != undefined ? action.payload.formAvatar : "";
      }

      if (action.payload.ticket) {
        state.upload[0].ticket = action.payload.ticket != undefined ? action.payload.ticket : "";
      }

      ////console.log(action.payload, "payload");

      // state.upload[0].avatarpic += action.payload.avatarpic != undefined ? action.payload.avatarpic : ""
      // state.upload[0].birthCertificate += action.payload.birthCertificate != undefined ? action.payload.birthCertificate : ""
      // state.upload[0].nationalCard += action.payload.nationalCard != undefined ? action.payload.nationalCard : ""
      // state.upload[0].passport += action.payload.passport
      // state.upload[0].avatarPicForeign += action.payload.avatarPicForeign
    },
    deleteFromForm: (state, action) => {
      // state.upload.push(action.payload)

      state.upload[0].avatarpic = action.payload.avatarpic;
      state.upload[0].birthCertificate = action.payload.birthCertificate;
      state.upload[0].nationalCard = action.payload.nationalCard;
      state.upload[0].passport = action.payload.passport;
      state.upload[0].avatarPicForeign = action.payload.avatarPicForeign;
    },
  },
});

export const { addToForm, deleteFromForm } = uploadSlice.actions;
export default uploadSlice.reducer;
